import { render, staticRenderFns } from "./RelationPessoaInput.vue?vue&type=template&id=a97241d6&"
import script from "./RelationPessoaInput.vue?vue&type=script&lang=js&"
export * from "./RelationPessoaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports